module.exports = __webpack_public_path__ + "media/images/smart_phone/item/kuchikomi-2844d2e65f65b005058750f1610b482f.png";